import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { GoogleButton as El } from '../../AuthGoogle'

const mapStateToProps = (state, params) => {
  return {
    text: state.localization.dictionary.login.loginGoogle,
  }
}

const onSuccess = (response) => {
  window.location.reload()
}

const onError = (error) => {
  // TODO: How should we handle these scenarios in this flow?

  // Captcha or CSRF error
  if (error.id === 5107) {
    // Show login with appropriate error message
    window.location.assign('/login?e=24')
  }

  // Google authed but not recognized account. Create it?
  if (error.id === 5104) {
    window.location.assign(`/signup_interim?email=${user.email}`)
  }
}

const GoogleButton = (props) => {
  return (
    <El
      children={ props.text }
      onError={ onError }
      onSuccess={ onSuccess } />
  )
}

const ConnectedGoogleButton = connect(
  mapStateToProps
)(GoogleButton)

export {
  ConnectedGoogleButton as GoogleButton
}



// WEBPACK FOOTER //
// ./client/Modules/AppAuthPage/containers/GoogleButton.js